"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copilot = exports.tuple = exports.array = exports.object = void 0;
var object_1 = require("./modules/object");
Object.defineProperty(exports, "object", { enumerable: true, get: function () { return __importDefault(object_1).default; } });
var array_1 = require("./modules/array");
Object.defineProperty(exports, "array", { enumerable: true, get: function () { return __importDefault(array_1).default; } });
var tuple_1 = require("./modules/tuple");
Object.defineProperty(exports, "tuple", { enumerable: true, get: function () { return __importDefault(tuple_1).default; } });
var copilot_1 = require("./modules/copilot");
Object.defineProperty(exports, "copilot", { enumerable: true, get: function () { return __importDefault(copilot_1).default; } });
